export default function tabValueReducer (state = 0, action) {
    switch (action.type) {
      case 'SET_TAB_VALUE':
        return action.payload;
      default:
        return state;
    }
  };
